import React, { useState } from 'react';
import N3rveLogo from './../../../images/N3rveLogo.png'
import './ArtistDetails.css'
import Select from 'react-select'
import { Link } from 'react-router-dom';

function ArtistDetails() {
const [name,setName] = useState()
const [genre,setGenre] = useState()
const genreOptions = [{ value: 'Alternative', label: 'Alternative' },
                      { value: 'Audiobooks', label: 'Audiobooks' },
                      { value: 'Blues', label: 'Blues' },
                      { value:'Children’s Music',  label:'Children’s Music'  },
                      { value: 'Classical', label: 'Classical' },
                      { value: 'Comedy', label: 'Comedy' },
                      { value: 'Country', label: 'Country' },
                      { value: 'Dance', label: 'Dance' },
                      { value: 'Electronic', label: 'Electronic' },
                      { value: 'Folk', label: 'Folk' },
                      { value: 'Hip hop/Rap', label: 'Hip hop/Rap' },
                      { value: 'Holiday', label: 'Holiday' },
                      { value: 'Inspirational', label: 'Inspirational' },
                      { value: 'Jazz', label: 'Jazz' },
                      { value: 'Latin', label: 'Latin' },
                      { value: 'New Age', label: 'New Age' },
                      { value: 'Opera', label: 'Opera' },
                      { value: 'Pop', label: 'Pop' },
                      { value: 'R&B/Soul', label: 'R&B/Soul' },
                      { value: 'Reggae', label: 'Reggae' },
                      { value: 'Rock', label: 'Rock' },
                      { value: 'Spoken Word', label: 'Spoken Word' },
                      { value: 'Soundtrack', label: 'Soundtrack' },
                      { value: 'Vocal', label: 'Vocal' },
                      { value: 'World', label: 'World' }]

  const changeGenreHandler = value => {
                setGenre(value)
                      }

const colourStyles = {
  control: styles => ({ ...styles,  borderColor: '#636468',
  backgroundColor:'#18191F',
  width: '29.75em',
  height: '3em',
  borderRadius:'8px',
  color:'rgba(255, 255, 255, 1)',
  marginTop:'0.8em'
 }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor:'#18191F' ,
      color:'rgba(255, 255, 255, 1)',
      cursor: isDisabled ? 'not-allowed' : 'default',
      marginTop:'-0.3em',
      marginBottom:'-0.3em'
    };
  },
  input: (styles) => ( {...styles , 
                          FontFamily:'ClashGrotesk-Variable,sans-serif',
                          FontSize:'1rem',
                          FontWeight: 'medium',
                          LineHeight: '150%',
                          LetterSpacing: '0%',
                          color:'rgba(255, 255, 255, 1)'}),
  singleValue : (styles) => ({ ...styles, 
                                  color:'rgba(255, 255, 255, 1)',
                                  FontFamily:'ClashGrotesk-Variable,sans-serif',
                                  FontSize:'1rem',
                                  FontWeight: 'medium',
                                  LineHeight: '150%',
                                  LetterSpacing: '0%'})
};

  return (
    <div className="ArtistDetailsContainer">
         <img src={N3rveLogo} alt="Nerve Logo" style={{width:'5.58em',height:'1em',marginLeft:'9.5em',marginTop:'1.75em'}}/>

        <div style={{display:'flex',flexDirection:'row'}}>
            <div className='WhatYourNameTxt'>
               What's Your <br/> Artist Name?
            </div>

            <div style={{display:'flex',flexDirection:'column',marginTop:'7em',marginLeft:'6em'}}>
                    <div className='YourInfoTxt'>ARTIST INFORMATION</div>

                    <div className='FormHeader'>Artist Name</div>
                    
                  <input
                  value={name}
                  onChange={e => setName(e.target.value)} 
                  className='FormInput'
                  type='text'
                  />

                    <div className='FormHeader'>Genre</div>
                    <Select options={genreOptions} value={genre} onChange={changeGenreHandler} 
                    components={{
                      IndicatorSeparator: () => null
                    }}
                    styles={
                      colourStyles
                    }
                    />

                    <div style={{display:'flex',flexDirection:'row',marginTop:'3.4em'}}>
                        <div className='Button'>
                          Back
                        </div>

                      <Link to="/Dashboard" className='Button'style={{backgroundColor:'#6D33C9',textDecoration:'none'}}>
                            <div >
                              Submit
                            </div>
                        </Link>
                    </div>
            </div>
        </div>
    </div>
  );
}

export default ArtistDetails;